import {useEffect, useRef} from 'react';
import {Animated} from 'react-native';
import {constant} from 'lodash/fp';

import {
  POPUP_STATE_ANIMATION_IN_PROGRESS,
  POPUP_STATE_VISIBLE,
} from '/enum/popupState.enum';

export const usePopupBackground = ({modalState, onAnimationComplete}: any) => {
  const fadeAnim = useRef(new Animated.Value(0));

  const startAnimation = (toValue: any, onComplete = constant(null)) => {
    Animated.timing(fadeAnim.current, {
      toValue,
      duration: 200,
      useNativeDriver: true,
    }).start(onComplete);
  };

  useEffect(() => {
    if (modalState === POPUP_STATE_VISIBLE) {
      startAnimation(1);
    } else if (modalState === POPUP_STATE_ANIMATION_IN_PROGRESS) {
      startAnimation(0, onAnimationComplete);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalState]);

  return {fadeAnim};
};
